declare function require(moduleName: string): any;
export const environment = {
    useMock: false,
    production: true,
    version: require("../../package.json").version,
    defaultSourcePrefix: "dev-us",
    company: {
        entityRegisteredName: 'Telit IoT Solutions, Inc.',
        entityName: 'Telit IoT Solutions, Inc.'
    },
    instances: {
        "engr-us" : {
            "key": "engr-us",
            "name": "Engineering-US",
            "endpoint": "engr-api.devicewise.com/api",
            "switchGroup": "engr",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "toesApi": "https://toes-engr.devicewise.net/private",
            "telitIccidPrefix": "89589"
        },
        "stage-us" : {
            "key": "stage-us",
            "name": "Stage-US",
            "endpoint": "stage-api.devicewise.com/api",
            "switchGroup": "stage",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "toesApi": "https://toes-engr.devicewise.net/private",
            "telitIccidPrefix": "89589"
        },
        "dev-us" : {
            "key": "dev-us",
            "name": "Developer-US",
            "endpoint": "api-dev.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://appcenter.telit.com",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "toesApi": "https://toes-dev.devicewise.net/private",
            "telitIccidPrefix": "89358"
        },
        "prod-us" : {
            "key": "prod-us",
            "name": "Production-US",
            "endpoint": "api-us.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://appcenter.telit.com",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "toesApi": "https://toes-prod.devicewise.net/private",
            "telitIccidPrefix": "89358"
        },
        "prod-de" : {
            "key": "prod-de",
            "name": "Production-DE",
            "endpoint": "api-de.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://appcenter.telit.com",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "toesApi": "https://toes-prod.devicewise.net/private",
            "telitIccidPrefix": "89358"
        },
        "cust-cu" : {
            "key": "cust-cu",
            "name": "China Unicom",
            "endpoint": "device1-api.10646.cn/api",
            "switchGroup": "cu",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "toesApi": "https://toes-engr.devicewise.net/private",
        },
        "cust-swisscom" : {
            "key": "cust-swisscom",
            "name": "Swisscom",
            "endpoint": "api.iotcloud.swisscom.com/api",
            "switchGroup": "swisscom",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "toesApi": "https://toes-engr.devicewise.net/private",
        },
        "cust-swisscom-test" : {
            "key": "cust-swisscom-test",
            "name": "Swisscom (Test)",
            "endpoint": "api-test.iotcloud.swisscom.com/api",
            "switchGroup": "swisscom",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "toesApi": "https://toes-engr.devicewise.net/private",
        }
    }
};

export const defaultAppCenterUrl = "https://portal-engr.telit.com";
export const maxNumberOfIccidsInRecruiter = 2000;
export const defaultDwopenEndpoint = "https://engr-api.devicewise.com/api";
export const unassignOrgId = "6f53c230-1cfa-11eb-adc1-000000000000";
